import React from 'react';
type IconProps = {
  className?: string;
  strokeWidth?: number;
};
const base = (className = 'w-7 h-7', strokeWidth = 1.5) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 48 48',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  className
});
// 1. Back — silhouette of a person from behind with spine
export const BackIcon = ({
  className,
  strokeWidth
}: IconProps) => <svg {...base(className, strokeWidth)} data-id="element-316">
    <circle cx="24" cy="11" r="5" data-id="element-317" />
    <path d="M14 38c0-8 4-14 10-14s10 6 10 14" data-id="element-318" />
    <path d="M24 21v17" data-id="element-319" />
    <path d="M21 27h6M21 32h6" data-id="element-320" />
  </svg>;
// 2. Abdomen — torso with abs lines
export const AbdomenIcon = ({
  className,
  strokeWidth
}: IconProps) => <svg {...base(className, strokeWidth)} data-id="element-321">
    <path d="M16 10c0 6 0 12 2 18s4 10 6 10 4-4 6-10 2-12 2-18" data-id="element-322" />
    <path d="M24 14v22" data-id="element-323" />
    <path d="M19 19h10M18 25h12M19 31h10" data-id="element-324" />
  </svg>;
// 3. Flanks — hourglass / waistline curves
export const FlanksIcon = ({
  className,
  strokeWidth
}: IconProps) => <svg {...base(className, strokeWidth)} data-id="element-325">
    <path d="M14 8c0 6 6 10 6 16s-6 10-6 16" data-id="element-326" />
    <path d="M34 8c0 6-6 10-6 16s6 10 6 16" data-id="element-327" />
    <path d="M18 24h12" data-id="element-328" />
  </svg>;
// 4. Legs — two leg silhouettes
export const LegsIcon = ({
  className,
  strokeWidth
}: IconProps) => <svg {...base(className, strokeWidth)} data-id="element-329">
    <path d="M16 8c0 6-1 12-2 20s-2 12-2 14" data-id="element-330" />
    <path d="M32 8c0 6 1 12 2 20s2 12 2 14" data-id="element-331" />
    <path d="M16 8h16" data-id="element-332" />
    <path d="M10 42h6M32 42h6" data-id="element-333" />
  </svg>;
// 5. Glutes — rounded shape
export const GlutesIcon = ({
  className,
  strokeWidth
}: IconProps) => <svg {...base(className, strokeWidth)} data-id="element-334">
    <path d="M10 16c0-4 4-8 8-8 3 0 5 2 6 4 1-2 3-4 6-4 4 0 8 4 8 8 0 8-4 24-14 24S10 24 10 16z" data-id="element-335" />
    <path d="M24 12v28" data-id="element-336" />
  </svg>;
// 6. Chin — profile face showing jawline
export const ChinIcon = ({
  className,
  strokeWidth
}: IconProps) => <svg {...base(className, strokeWidth)} data-id="element-337">
    <path d="M16 10c0-1 1-2 2-2h6c4 0 8 4 8 9v6c0 2-1 4-2 5-1 1-1 2-1 3v3c0 3-3 5-6 5h-3c-2 0-4-1-4-3" data-id="element-338" />
    <circle cx="26" cy="22" r="1" fill="currentColor" data-id="element-339" />
    <path d="M22 28c2 1 4 1 6 0" data-id="element-340" />
  </svg>;
// 7. Arms — bicep flexed arm
export const ArmsIcon = ({
  className,
  strokeWidth
}: IconProps) => <svg {...base(className, strokeWidth)} data-id="element-341">
    <path d="M8 28c4-2 8-2 12 0s7 6 7 12" data-id="element-342" />
    <path d="M14 22c2-4 6-8 12-8 7 0 12 4 12 10 0 4-3 8-7 8" data-id="element-343" />
    <path d="M22 18c2 0 4 2 4 4" data-id="element-344" />
  </svg>;
// 8. Chest — chest outline
export const ChestIcon = ({
  className,
  strokeWidth
}: IconProps) => <svg {...base(className, strokeWidth)} data-id="element-345">
    <path d="M10 14c0-2 2-4 4-4h20c2 0 4 2 4 4 0 6-2 12-6 14-2 1-4 3-4 6 0 2-2 4-4 4s-4-2-4-4c0-3-2-5-4-6-4-2-6-8-6-14z" data-id="element-346" />
    <circle cx="18" cy="22" r="1.5" data-id="element-347" />
    <circle cx="30" cy="22" r="1.5" data-id="element-348" />
  </svg>;
export const bodyIconMap: Record<string, React.FC<IconProps>> = {
  back: BackIcon,
  abdomen: AbdomenIcon,
  flanks: FlanksIcon,
  legs: LegsIcon,
  glutes: GlutesIcon,
  chin: ChinIcon,
  arms: ArmsIcon,
  chest: ChestIcon
};